<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid" :disabled="readonly">

      <ressource-info-bulle code="APRP-AP-1" />

      <fieldset>
        <legend class="text-h6 text-sm-h5">Lettre de motivation</legend>
        <div>
          <Attachment
            ref="motivationAttachment"
            file-prefix="form_lettre_motivation_paear"
            @completeEvent="saveNextAttachment"
            :min-required="1"
            @refreshEvent="validateForm(false)"
          />
        </div>
      </fieldset>

      <ressource-info-bulle code="APRP-AP-2" />

      <fieldset>
        <legend class="text-h6 text-sm-h5">Motifs de renonciation</legend>
        <template>

          <v-list flat subheader>
            <v-list-item-group>
              <list-item-with-checkbox
                v-for="fd in motifsRenonciation"
                v-bind:key="fd.id"
                :value="fd.value"
                :texte="fd.lang00"
                :disabled="fd.disabled"
                :property-name="fd.id.toString()"
                @updateChoix="updateChoix"
              />
            </v-list-item-group>
          </v-list>
          <v-input :value="this.motifsRenonciation.filter((ar) => ar.value)" :rules="rules.motifsRenonciation"/>
        </template>
        <template v-if="isAutresMotifs">
          <p class="mentionLegal">
            Explications des motifs de renonciation:
          </p>
          <v-text-field
            v-if="isAutresMotifs"
            v-model="demandeAdmission.explicationsMotif"
            class="cssRequired"
            label="Explications"
            :rules="rules.explicationsMotif"
            required
          />
        </template>
      </fieldset>

      <!-- Autorisation de pratique -->
      <fieldset>
        <legend class="text-h6 text-sm-h5">Autorisation(s) de pratique demandée(s)</legend>

        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">Indiquez quelle(s) activité(s) réservée(s) fait l’objet de la demande d’autorisation pour un permis spécial</th>
              <th class="text-right">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="item in listeAutorisationsDePratiqueActive"
              :key="item.name"
            >
              <td class="pt-4">
                <v-autocomplete
                  v-model="item.autorisation"
                  :item-text="itemText"
                  :item-value="itemValue"
                  :items="listeAutorisationsFilter(item)"
                  :rules="rules.autorisation"
                  required
                  label="Autorisation"
                  return-object
                ></v-autocomplete>
              </td>
              <td class="text-right pt-4">
                <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="#8b0000" icon v-bind="attrs" @click="deleteRow(item)" v-on="on">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Retirer cette autorisation de pratique</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>

        <template>
          <div class="mt-6 d-flex align-center">
            <v-btn :disabled='!canAdd' color="primary" @click="ajouter()">ajouter</v-btn>
            <v-input :value="this.listeAutorisationsDePratiqueActive" :rules="rules.autorisations" class="ml-4"/>
          </div>
        </template>
      </fieldset>
    </v-form>

    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid"
             color="secondary"
             @click="saveAndContinueLater()">Enregistrer et terminer plus tard
      </v-btn>
      <v-btn :disabled="!valid" color="primary" @click="saveAndContinue()">
        Suivant
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import Loader from "../Loader"
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin"
import PageReadonlyFormulaireAdmissionMixin from "@/mixins/pageReadonlyFormulaireAdmissionMixin"
import AttachementFormulaireMixin from "@/mixins/attachementFormulaireMixin"
import Ressource from "../ui/Ressource.vue";
import Attachment from "../attachments/Attachment.vue";
import ListItemWithCheckbox from "../common/ListItemWithCheckbox.vue";

export default {
  mixins: [
    NavigationPageFormulaireMixin,
    PageReadonlyFormulaireAdmissionMixin,
    AttachementFormulaireMixin,
  ],
  components: {
    ListItemWithCheckbox,
    Attachment,
    Ressource,
    Loader: Loader,
  },
  props: {
    routeName: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      overlay: false,
      messageSelector: "",
      valid: false,
      rules: {
        categorieAutorisation: [(v) => (!!v && v.length !== 0) || "Le type d'autorisation est requis",],
        autorisation: [(v) => (!!v && v.length !== 0) || "L'autorisation est requise",],
        motifsRenonciation: [
          (v) => (!!v && v.length > 0) || "Vous devez sélectionner au moins une valeur",
        ],
        autorisations: [
          (v) => (!!v && v.length > 0) || "Vous devez sélectionner au moins une valeur",
        ],
        explicationsMotif: [(v) => (!!v && v.length < 100) || "Cette valeur est requise (max 100)",],
      },
      motifsRenonciation: [],
      refreshKey: 0, // hack: permet de force le re-calcul d'une computed
    }
  },
  computed: {
    ...mapGetters({
      demandeAdmissionId: "DemandeAdmission/GET_DEMANDEADMISSIONID",
      demandeAdmissionPpId: "DemandeAdmission/GET_CONTACTID",
      demandeAdmission: "DemandeAdmission/GET_DEMANDEADMISSION",
      getAutorisations: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
      listeMotifsRenonciation: "Catalogue/getMotifsRenonciation",
      listeCategories: "Catalogue/GET_CATEGORIEAUTORISATION",
      listeFilteredAutorisations: "Catalogue/GET_AUTORISATIONS_BY_CATEGORIEAUTORISATION",
    }),
    canAdd () {
      return this.listeAutorisationsFilter(null).length > 0
    },
    listeAutorisationsDePratique () {
      return this.getAutorisations.filter(a => a.demandeAdmission === this.demandeAdmissionId)
    },
    listeAutorisationsDePratiqueActive () {
      this.refreshKey; // vue traque la propriété

      return this.listeAutorisationsDePratique.filter(a => a.deleted !== true)
    },
    listeCategoriesAutorisationsFilter () {
      return this.listeCategories.filter(c => c.id === this.$catalogues.categorieAutorisation.personneAutorisee)
    },
    isAutresMotifs() {
      return (
        this.motifsRenonciation
          .find((ar) => ar.id === this.$catalogues.motifsRenonciationDemandeAdmission.autresMotifs)?.value === true
      )
    },
  },
  created () {
    this.fetchItems()
  },
  methods: {
    ...mapMutations({
      addAutorisationDePratique: "AutorisationDePratique/ADD_AUTORISATIONDEPRATIQUE",
      removeAutorisationDePratique: "AutorisationDePratique/REMOVE_AUTORISATIONDEPRATIQUE",
      setAutorisationDePratiqueDeleted: "AutorisationDePratique/setAutorisationDePratiqueDeleted",
    }),
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      fetchDemandeAdmission: "DemandeAdmission/fetchDemandeAdmission",
      getAutorisationDePratiqueByContactId: "AutorisationDePratique/getAutorisationDePratiqueByContactId",
      getDocumentsByContactId: "Documents/getDocumentsByContactId",
      updateDemandeAdmission: "DemandeAdmission/updateDemandeAdmission",
      updateAutorisationDePratique: "AutorisationDePratique/updateAutorisationDePratique",
      createAutorisationDePratique: "AutorisationDePratique/createAutorisationDePratique",
      deleteAutorisationDePratique: "AutorisationDePratique/deleteAutorisationDePratique",
      demandeTerminee: "DemandeInscription/demandeTerminee",
    }),
    listeAutorisationsFilter (item) {
      return this.listeFilteredAutorisations(this.$catalogues.categorieAutorisation.personneAutorisee)
        .filter(a => item?.autorisation?.id === a.id || this.listeAutorisationsDePratiqueActive.some(ap => ap.autorisation?.id === a.id) === false)
    },
    async fetchItems () {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        const requests = [
          this.getCatalogue(this.$cataloguesDesc.categorieAutorisation),
          this.getCatalogue(this.$cataloguesDesc.autorisationDePatique),
          this.getCatalogue(this.$cataloguesDesc.motifsRenonciation),
        ]

        if (this.demandeAdmissionPpId) {
          requests.push(this.getAutorisationDePratiqueByContactId(this.demandeAdmissionPpId))
          requests.push(this.getDocumentsByContactId(this.demandeAdmissionPpId))
        }

        if (this.demandeAdmissionId) {
          await this.fetchDemandeAdmission(this.demandeAdmissionId);
        }

        await Promise.all(requests)

        // Liste les uploads de fichiers
        this.refsUpload = [
          () => this.$refs.motivationAttachment,
        ]

        // définition des coches en fonction du catalogue et des éléments déjà sélectionnés
        let autreCoche = false
        this.listeMotifsRenonciation.forEach((property) => {
          const fd = { ...property }
          fd.value = false

          if (this.demandeAdmission.motifsRenonciation.find((ar) => ar.id === fd.id)) {
            fd.value = true

            if (fd.id === this.$catalogues.motifsRenonciationDemandeAdmission.autresMotifs) {
              autreCoche = true
            }
          }

          this.motifsRenonciation.push(fd)
        })
        this.sanitizeMotifsRenonciation(autreCoche)

        this.validateForm(true)
        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    saveAndContinue () {
      this.redirectValue = "continue"

      if (this.readonly) {
        return this.redirect()
      }

      this.save()
    },
    async save () {
      this.validateForm()
      if (!this.valid) {
        return
      }

      this.messageSelector = "Save"
      this.overlay = true

      // set motifsRenonciation from locale state
      this.demandeAdmission.motifsRenonciation = this.motifsRenonciation.filter((fd) => fd.value)
      await this.updateDemandeAdmission(this.demandeAdmission);

      // Autorisation de pratique
      for (const element of this.listeAutorisationsDePratique) {

        if (element.deleted === true) {
          if (element.id !== null) {
            await this.deleteAutorisationDePratique(element.id) // server
          } else {
            this.removeAutorisationDePratique(element) // local
          }
          continue
        }

        if (element.id === null) {
          await this.createAutorisationDePratique(element)
        } else {
          await this.updateAutorisationDePratique(element)
        }
      }

      this.saveAttachments(
        "demandeAdmission",
        this.demandeAdmissionId,
        () => {
          this.overlay = false;
          this.redirect();
        })
    },
    ajouter () {
      this.addAutorisationDePratique({
        id: null,
        pp: this.demandeAdmissionPpId,
        demandeAdmission: this.demandeAdmissionId,
        categorieAutorisation: this.listeCategoriesAutorisationsFilter[0],
        autorisation: null,
        statut: null,
        deleted: false,
      })
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    validateForm (resetValidation = false) {
      this.valid = (this.$refs.form?.validate() || false)
      && (!!this.listeAutorisationsDePratiqueActive || this.listeAutorisationsDePratiqueActive.length === 0)

      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
    deleteRow(item) {
      item.deleted = true
      this.refreshKey++ // hack: trigger un refresh manuel car vuex ne voit pas le changement même en passant par une mutation
    },
    updateChoix(payload) {
      const dataId = parseInt(payload.field)
      this.motifsRenonciation.filter((ar) => ar.id === dataId).forEach((c) => (c.value = payload.choix)) // simplification d'écriture, doit se produire 0 ou 1 fois

      if (dataId === this.$catalogues.motifsRenonciationDemandeAdmission.autresMotifs) {
        this.sanitizeMotifsRenonciation(payload.choix)
      }

      // vide la précision si la question est masquée
      if (!this.isAutresMotifs) {
        this.demandeAdmission.explicationsMotif = null
      }
    },
    // assure la cohérence des cases cochées
    sanitizeMotifsRenonciation(autreValue) {
      // autre pilote la désactivation des autres cases
      this.motifsRenonciation
        .filter((ar) => ar.id !== this.$catalogues.motifsRenonciationDemandeAdmission.autresMotifs)
        .forEach((c) => (c.disabled = autreValue))

      // si coché on veux vider les autres coches
      if (autreValue === true) {
        this.motifsRenonciation
          .filter((ar) => ar.id !== this.$catalogues.motifsRenonciationDemandeAdmission.autresMotifs)
          .forEach((c) => (c.value = false))
      }
    },
  },
}
</script>

<style>
</style>